// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OD-tE","right":"Footer_right__1TL9K","buttons":"Footer_buttons__2jNdr"};